module.exports = __webpack_public_path__ + "static/spiedge-slider-30c4d96a4d1a310d44e84dab0e2f071f.png";